import React from "react";
import I18n from 'i18n-js/index.js.erb';
import LineIconBaseImg from 'assets/booking/btn_login_base.png';

export const BookingStartInfo = ({start_at}) => (
  <div className="start-yet-view">
    <h3 className="title">
      {I18n.t("booking_page.start_yet.title")}
    </h3>
    <div className="message">
      {I18n.t("booking_page.start_yet.message1")}
      <br />
      <strong>{start_at}～</strong>
      <br />
      {I18n.t("booking_page.start_yet.message2")}
    </div>
  </div>
)

export const BookingEndInfo = () => (
  <div className="booking-info">
    <div className="ended-view">
      <h3 className="title">
        {I18n.t("booking_page.ended.title")}
      </h3>
      <div className="message">
        {I18n.t("booking_page.ended.message1")}
        <br />
        {I18n.t("booking_page.ended.message2")}
      </div>
    </div>
  </div>
)

export const ServiceStartInfo = ({start_at}) => (
  <div className="start-yet-view">
    <h3 className="title">
      {I18n.t("booking_page.start_yet.title")}
    </h3>
    <div className="message">
      {I18n.t("booking_page.start_yet.message1_online_service")}
      <br />
      <strong>{start_at}～</strong>
      <br />
      {I18n.t("booking_page.start_yet.message2")}
    </div>
  </div>
)

export const ServiceEndInfo = () => (
  <div className="booking-info">
    <div className="ended-view">
      <h3 className="title">
        {I18n.t("booking_page.ended.title")}
      </h3>
      <div className="message">
        {I18n.t("booking_page.ended.message1_online_service")}
        <br />
        {I18n.t("booking_page.ended.message2")}
      </div>
    </div>
  </div>
)


export const CheckInLineBtn = ({social_account_add_friend_url, btn_text, children}) => (
  social_account_add_friend_url ? (
    <div className="message centerize">
      {children}
      <a href={social_account_add_friend_url} className="btn line-button with-wording with-logo">
        <img src={LineIconBaseImg} />
        {btn_text || I18n.t("booking_page.done.check_in_line_btn")}
      </a>
    </div>
  ) : <></>
)

export const AddLineFriendInfo = ({social_account_add_friend_url, children}) => (
  social_account_add_friend_url ? (
    <div className="message centerize">
      {children || <h3 className="desc" dangerouslySetInnerHTML={{ __html: I18n.t("booking_page.done.add_friend_messages_html") }} />}
      <a href={social_account_add_friend_url} className="btn line-button with-wording with-logo">
        <img src={LineIconBaseImg} />
        {I18n.t("booking_page.done.add_friend_btn")}
      </a>
    </div>
  ) : <></>
)

export const LineLoginBtn = ({social_account_login_url, btn_text, children}) => {
  if (!social_account_login_url) return <></>;
  
  const url = new URL(social_account_login_url, window.location.origin);
  const params = Object.fromEntries(url.searchParams);
  const formRef = React.useRef(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    // Instagram のアプリ内ブラウザでは、LINE アプリから Safari などに戻されてログインを通せないため、
    // 外部ブラウザで開き直してもらう（LINE の推奨。アプリ内から Safari を開く手段はない）
    if (/Instagram/.test(navigator.userAgent)) {
      alert(I18n.t("common.line_login_in_instagram_message"));
      return;
    }
    const form = formRef.current;
    if (!form) return;
    const tokenInput = form.querySelector('input[name="authenticity_token"]');
    if (tokenInput) {
      tokenInput.value = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '';
    }
    form.submit();
  };
  
  return (
    <div className="message centerize">
      {children}
      <form ref={formRef} method="post" action={url.pathname} onSubmit={handleSubmit}>
        <input type="hidden" name="authenticity_token" value="" />
        {Object.entries(params).map(([key, value]) => (
          <input key={key} type="hidden" name={key} value={value} />
        ))}
        <button type="submit" className="btn line-button with-wording with-logo" style={{border: 'none', cursor: 'pointer', padding: '10px 20px'}}>
          <img src={LineIconBaseImg} />
          {btn_text || I18n.t("common.line_login_btn_word")}
        </button>
      </form>
    </div>
  );
}

